<script>
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    export let actions = [];
    let buttons = {
        cancel: "Cancel",
        close : "Close",
        create: "Create New",
        default: "Default",
        edit: "Edit",
        export: "Export",
        help: "Help Request",
        next: "Next >>",
        print: "Print",
        reload_analysis : "Reload Analysis",
        save: "Save",
        save_and_send: "Save & Send",
        send: "Send",
        survey_analysis : "Survey Analysis",
        corr_analysis : "Correlation Analysis"
    }
    let isDisabledStartAnalysis = false;
    let isDisabledReloadAnalysis = false;

    function willStartSurveyAnalysis() {
        isDisabledStartAnalysis = true;
        dispatch("survey_analysis");
    }

    function willStartCorrelationAnalysis() {
        isDisabledStartAnalysis = true;
        dispatch("corr_analysis");
    }

    function willReloadAnalysis() {
        isDisabledReloadAnalysis = true;
        dispatch("reload_analysis");
    }
</script>

{#if actions.length > 0}
<div class="button-panel">
    {#each actions as action}
        {#if ["cancel", "close", "default", "export", "print"].includes(action)}
            <button class="modal-button a1" on:click={() => dispatch(action)}>
                {buttons[action]}
            </button>
        {:else if action == "survey_analysis"}
            <button class="modal-button a1" disabled={isDisabledStartAnalysis} on:click={willStartSurveyAnalysis}>
                {buttons[action]}
            </button>
        {:else if action == "corr_analysis"}
            <button class="modal-button a1" disabled={isDisabledStartAnalysis} on:click={willStartCorrelationAnalysis}>
                {buttons[action]}
            </button>
        {:else if action == "reload_analysis"}
            <button class="modal-button a1" disabled={isDisabledReloadAnalysis} on:click={willReloadAnalysis}>
                {buttons[action]}
            </button>
        {:else}
            <button class="modal-button a2" on:click={() => dispatch(action)}>
                {buttons[action]}
            </button>
        {/if}
    {/each}
</div>
{/if}

<style>
    .button-panel {
        position: relative;
        bottom: 0;
        width: 100%;
        border-top: lightgray solid 0.25px;
        padding: 0.25rem 0;
        text-align: center;
        max-height: 10vh;
    }
    .modal-button {
        color: #0A6EBD;
        border-radius: 5px;
        cursor: pointer;
        margin: 0.25rem 0.5rem;
        padding: 0.5rem 1rem;
    }
    .modal-button:hover {
        background-color: rgb(248,248,248);
        border: 1px solid #0A6EBD;
    }
    .a1 {
        border: 1px solid lightgray;
    }
    .a2 {
        border: 1px solid rgb(67, 148, 11);
    }

</style>
